import React from "react";
import styles from "./aiDisclaimer.module.css";
import { AI_DISCLAIMER_TEXT, resolveAiDisclaimerLanguage } from "./aiDisclaimer.constants";

type AiDisclaimerProps = {
  // The OUTPUT_LANGUAGE value the results were generated with ("hebrew" | "english").
  // Decide once per screen and pass the same value to every consumer.
  outputLanguage?: string | null;
};

// Permanent, non-dismissible AI disclaimer. Render once at the bottom of each AI results screen.
const AiDisclaimer = ({ outputLanguage }: AiDisclaimerProps) => {
  const language = resolveAiDisclaimerLanguage(outputLanguage);
  return (
    <div
      className={styles.disclaimer}
      dir={language === "hebrew" ? "rtl" : "ltr"}
      lang={language === "hebrew" ? "he" : "en"}
      role="note"
      data-testid="ai-disclaimer"
    >
      {AI_DISCLAIMER_TEXT[language]}
    </div>
  );
};

export default AiDisclaimer;
